import React, { forwardRef, useMemo } from 'react';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../assets/fonts/selection.json';

import './styles.scss';

export type IconColorOptions =
    | 'default'
    | 'warn'
    | 'danger'
    | 'success'
    | 'highlight'
    | 'disabled'
    | 'white'
    | 'info'
    | 'grey'
    | 'purple';
interface Props {
    icon: string;
    color?: IconColorOptions;
    size?: string | number;
    className?: string;
}

// eslint-disable-next-line react/display-name
export const Icon = forwardRef<HTMLDivElement, Props>(
    ({ icon, color = 'default', size = '16', className = '' }, ref) => {
        const colorClassName = useMemo(() => {
            if (icon.includes('duonote')) {
                switch (color) {
                    case 'success':
                        return 'razem-app-icon--success-duo';
                    case 'warn':
                        return 'razem-app-icon--warn-duo';
                    case 'default':
                    default:
                        return 'razem-app-icon--default';
                }
            }

            switch (color) {
                case 'warn':
                    return 'razem-app-icon--warn';
                case 'danger':
                    return 'razem-app-icon--danger';
                case 'highlight':
                    return 'razem-app-icon--highlight';
                case 'success':
                    return 'razem-app-icon--success';
                case 'white':
                    return 'razem-app-icon--white';
                case 'disabled':
                    return 'razem-app-icon--disabled';
                case 'info':
                    return 'razem-app-icon--info';
                case 'grey':
                    return 'razem-app-icon--grey';
                case 'purple':
                    return 'razem-app-icon--purple';
                case 'default':
                default:
                    return 'razem-app-icon--default';
            }
        }, [color, icon]);

        return (
            <div className={`razem-app-icon ${className}`} ref={ref}>
                <IcomoonReact className={`${colorClassName}`} iconSet={iconSet} size={size} icon={icon} />
            </div>
        );
    },
);
